import StateReadonly from './StateModel';
import { User } from 'oidc-client';

export const selectUser = (state: StateReadonly): Readonly<User> | undefined =>
   state.oidc.user;

export const selectIsUserLoading = (state: StateReadonly): boolean =>
   state.oidc.isLoadingUser;
